import type { MenuProps } from 'antd';
import { ROUTES } from '../../../routes';

export const FORMATION = (history: any) => {
  const items: MenuProps['items'] = [
    {
      key: '0',
      label: 'Définitions',
      onClick: () => {
        history.push(ROUTES.FORMATION.DEFINITIONS);
      },
    },
    {
      key: '1',
      label: 'Module Obligations',
      children: [
        {
          key: '1-1',
          label: "Gérer un portefeuille d'obligations",
        },
        {
          key: '1-2',
          label: 'Gestion des risques (Obligations)',
        },
        {
          key: '1-3',
          label: 'Réaliser la gestion des produits de taux et dérivés de taux',
        },
        {
          key: '1-4',
          label: 'Strategie de trading (indicateurs techniques)',
        },
        {
          key: '1-5',
          label: 'Strategie de trading (analyse fondamentale)',
        },
      ],
    },
    {
      key: '2',
      label: 'Module Marché financiers',
      children: [
        {
          key: '2-1',
          label: 'Les marchés financiers et instruments financiers',
        },
        {
          key: '2-2',
          label: 'Présentation générale du marché des titres publics',
        },
        {
          key: '2-3',
          label: 'Analyse du marché des titres publics CEMAC',
        },
        {
          key: '2-4',
          label: 'Les instruments dérivés sur le marché des titres publics',
        },
        {
          key: '2-5',
          label: 'Les bonnes pratiques de gestion de la dette publique',
        },
        {
          key: '2-6',
          label: 'Le rôle du marché secondaire des titres publics',
        },
        {
          key: '2-7',
          label:
            'Les opportunités de financement alternatif pour le secteur public',
        },
      ],
    },
    {
      key: '3',
      label: 'MoranjEtrade',
      children: [
        {
          key: '3-1',
          label: 'MoranjEtrade Terminal',
        },
      ],
    },
    {
      key: '4',
      label: 'Modules Marché Interbancaire',
      children: [
        {
          key: '4-1',
          label: 'Introduction au marché interbancaire',
        },
        {
          key: '4-2',
          label: 'Acteurs du marché interbancaire',
        },
        {
          key: '4-3',
          label: 'Produits financiers sur le marché interbancaire',
        },
        {
          key: '4-4',
          label: 'Fonctionnement du marché interbancaire',
        },
        {
          key: '4-5',
          label: 'Rôle de la Banque Centrale',
        },
        {
          key: '4-6',
          label: 'Taux du marché interbancaire',
        },
        {
          key: '4-7',
          label: 'Risques associés au marché interbancaire',
        },
        {
          key: '4-8',
          label: 'Réglementation du marché interbancaire',
        },
      ],
    },
    {
      key: '5',
      label: 'Modules Titres',
      children: [
        {
          key: '5-1',
          label: 'Evaluation et rendement d une oblidation',
        },
        {
          key: '5-2',
          label: 'Historique et organisation actuelle du marché',
        },
        {
          key: '5-3',
          label: 'Aspects économiques et financiers',
        },
        {
          key: '5-4',
          label: 'Succès des Green Titres',
        },
      ],
    },
    {
      key: '6',
      label: 'Fiscalité & Comptabilité',
      children: [
        {
          key: '6-1',
          label: 'Introduction à la comptabilité financière',
          onClick: () => {
            history.push(ROUTES.FISCA.COMPTA_FINANCE);
          },
        },
        {
          key: '6-2',
          label: 'Comptabilité des obligations',
          onClick: () => {
            history.push(ROUTES.FISCA.COMPTA_OBLIG);
          },
        },
        {
          key: '6-3',
          label: 'Fiscalité des obligations',
          onClick: () => {
            history.push(ROUTES.FISCA.FISCALITE_OBLIG);
          },
        },
        {
          key: '6-4',
          label: 'Analyse des états financiers',
          onClick: () => {
            history.push(ROUTES.FISCA.ANALYSE_ETAT);
          },
        },
        {
          key: '6-5',
          label: 'Gestion des risques financiers',
          onClick: () => {
            history.push(ROUTES.FISCA.RISQUE_FINANCE);
          },
        },
        {
          key: '6-6',
          label: 'Éthique et réglementation',
          onClick: () => {
            history.push(ROUTES.FISCA.ETHIQUE_REGL);
          },
        },
      ],
    },
    {
      key: '6',
      label: 'Règlementation',
      onClick: () => {
        history.push(ROUTES.REGLEMENTATION.REGION);
      },
    },
  ];
  return items;
};

// export const FORUM = (history: any) => {
//   const items: MenuProps['items'] = [
//     {
//       key: '0',
//       label: 'Accueil',
//       onClick: () => {
//         history.push(ROUTES.FORUM.PAGE);
//       },
//     },
//     // {
//     //   key: '1',
//     //   label: 'Categories',
//     //   children: FORUMS?.map((f: forumType) => ({
//     //     key: f.pk,
//     //     label: f.fields.topic,
//     //     onClick: () => {
//     //       history.push(ROUTES.FORUM.TOPIC(f.pk));
//     //     },
//     //   })),
//     // },
//     {
//       key: '1',
//       label: 'Nouveau Forum',
//       onClick: () => {
//         history.push(ROUTES.FORUM.POSTFORM);
//       },
//     },
//   ];
//   return items;
// };

export const SUB_MENUS = {
  [ROUTES.FORMATION.PAGE]: [
    {
      key: '0',
      label: 'Définitions',
      path: ROUTES.FORMATION.DEFINITIONS,
    },
    {
      key: '1',
      label: 'Module Obligations',
      dropdown: true,
      children: [
        {
          key: '1-1',
          label: "Gérer un portefeuille d'obligations",
          path: ROUTES.FORMATION.DEFINITIONS,
        },
      ],
    },
    {
      key: '2',
      label: 'Module Marché financiers',
      dropdown: true,
      children: [
        {
          key: '2-1',
          label: 'Les marchés financiers et instruments financiers',
          path: ROUTES.FORMATION.DEFINITIONS,
        },
      ],
    },
    {
      key: '3',
      label: 'MoranjEtrade',
    },
  ],
  [ROUTES.NETWORK.BOURSE]: [
    {
      key: 'network1',
      label: 'Sociétés de bourse',
      path: ROUTES.NETWORK.BOURSE,
    },
    { key: 'network2', label: 'Banques', path: ROUTES.NETWORK.BOURSE },
    { key: 'network3', label: 'SVT', path: ROUTES.NETWORK.BOURSE },
  ],
  [ROUTES.PANEL.CLIENTELE.CLIENTS]: [
    {
      key: 'panel1',
      label: 'Gestion de la clientele',
      path: ROUTES.PANEL.CLIENTELE.CLIENTS,
    },
    {
      key: 'panel2',
      label: 'KYC / AML',
      path: ROUTES.PANEL.KYC,
    },
    {
      key: 'panel3',
      label: 'CRM',
      dropdown: true,
      children: [
        {
          key: 'panel3-1',
          label: 'Opportunité',
          path: ROUTES.PANEL.COMPTABILITE.COMPTE,
        },
        {
          key: 'panel3-2',
          label: 'Gestion des activités',
          path: ROUTES.PANEL.COMPTABILITE.GRAND_LIVRE,
        },
      ],
    },
  ],
  [ROUTES.PANEL.EMISSION.TITRE]: [
    {
      key: 'titre1',
      label: 'Gestion des titres',
      path: ROUTES.PANEL.EMISSION.TITRE,
    },
    {
      key: 'titre2',
      label: 'Compta',
      dropdown: true,
      children: [
        {
          key: 'titre2-1',
          label: 'Comptes',
          path: ROUTES.PANEL.COMPTABILITE.COMPTE,
        },
        {
          key: 'titre2-2',
          label: 'Grand Livre & Balance Générale',
          path: ROUTES.PANEL.COMPTABILITE.GRAND_LIVRE,
        },
      ],
    },
    {
      key: 'titre3',
      label: 'Dashboard PNL',
      path: ROUTES.REPORTING.PORTEFEUILLE,
    },
  ],
  [ROUTES.DASHBOARD.PAGE]: [
    {
      key: 'transac1',
      label: 'Etrade',
      path: ROUTES.DASHBOARD.PAGE,
    },
    {
      key: 'transac2',
      label: 'Operation Back Office',
      path: ROUTES.REPORTING.TITRE,
    },
  ],
  [ROUTES.ADMIN.CONSOLE]: [
    {
      key: 'sadmin1',
      label: 'Gestion des clients MoranjEtrade',
      path: ROUTES.ADMIN.CONSOLE,
    },
    {
      key: 'sadmin2',
      label: 'Gestion des Packs',
      path: ROUTES.ADMIN.PACK,
    },
    {
      key: 'sadmin3',
      label: 'Gestion des Paramètres',
      path: ROUTES.ADMIN.PARAMETER,
    },
    {
      key: 'sadmin4',
      label: 'Reporting',
      path: ROUTES.ADMIN.REPORTING,
    },
  ],
  [ROUTES.PANEL.ADMIN.PARTENAIRE]: [
    {
      key: 'admin1',
      label: 'Gestion des partenaires',
      path: ROUTES.PANEL.ADMIN.PARTENAIRE,
    },
    {
      key: 'admin2',
      label: 'Gestion des utilisateurs/profils',
      path: ROUTES.PANEL.ADMIN.GESTION_USERS_PROFIL,
    },
    {
      key: 'admin3',
      label: 'Gestion des mots de passe',
      path: ROUTES.PANEL.ADMIN.GESTION_PASSWORD,
    },
  ],
};
